import styled from 'styled-components';
import Colors from '../../../constants/colors';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px 40px;
  background: ${Colors.shade06};
  position: relative;
`;

export const Title = styled.h3`
  font-size: 24px;
  line-height: 29px;
  color: ${Colors.shade01};
  margin: 0 10px;
  height: 29px;
`;
